import { Node } from "../Node";
import { AbstractProperty } from "./AbstractProperty";
import { json, MetadataRow } from "../../global";

export class PSubNode<N extends Node> extends AbstractProperty<N, Node> {
  seamless;

  constructor(args) {
    super({
      type: "SubNode",
      showBig: true,
      seamless: true,
      ...args,
    });
  }

  createDefault() {
    throw new Error("not intended");
    return null;
  }

  typeCheck(value: Node) {
    throw new Error("not intended");
    return null;
  }

  get(): N {
    return this.node[this.name];
  }

  set(value: N) {
    throw new Error("not intended");
    return null;
  }

  toJSON(): json {
    return this.get().toJSON();
  }

  fromJSON(json: json): this {
    const j = json[this.name];
    this.get().fromJSON(j ?? {});
    return this;
  }

  fromMetadataRow(metadataRow: MetadataRow): this {
    throw new Error("not intended");
    return this;
  }

  toThree<ThreeInstanceType>(instance: ThreeInstanceType) {
    // @ts-ignore
    this.get().toThree(instance[this.getNameThree()]);
  }

  fromThree<ThreeInstanceType>(instance: ThreeInstanceType) {
    // @ts-ignore
    this.get().fromThree(instance[this.getNameThree()]);
  }

  threeToInternalFormat(value) {
    throw new Error("not intended");
  }
}
